import type { ScoutRecord } from "./services/scouts";
import type { DeveloperCaoLink } from "./developer-cao-deep-link";
import { getSystemScoutTimezone } from "./scout-timezone";

export function isDeveloperCaoScout(scout: Pick<ScoutRecord, "mobileBridge">) {
  return (
    scout.mobileBridge?.kind === "developer-cao" ||
    scout.mobileBridge?.source === "developer-cao"
  );
}

export function developerCaoScoutInput(
  link: DeveloperCaoLink,
): Partial<ScoutRecord> {
  const label = link.sprint || "Developer Mode";
  const scheduleId = `developer-cao-hourly-${link.sprint || "developer"}`;
  return {
    name: `Developer CAO: ${label}`,
    instructions: developerInstructions(link),
    status: "active",
    provider: "nous",
    model: null,
    conversationId: null,
    triggerConfig: [
      { type: "manual", enabled: true, keywords: [] },
      {
        type: "schedule",
        enabled: true,
        schedule: "0 * * * *",
        timezone: getSystemScoutTimezone(),
        keywords: [],
        cursor: { scheduleId },
      },
    ],
    toolPolicies: [],
    mobileBridge: {
      kind: "developer-cao",
      source: "developer-cao",
      badge: "Developer",
      command: link.sprint
        ? `CAO-developer-mode enable --orchestrate ${link.sprint}`
        : "CAO-developer-mode enable",
      repo: link.repo,
      plan: link.plan,
      sprint: link.sprint,
      goal: link.goal,
      model: link.model,
      delayMinutes: link.delayMinutes,
      hourlyCheck: true,
      createdFromDevice: true,
    },
  };
}

function developerInstructions(link: DeveloperCaoLink): string {
  const label = link.sprint || "Developer Mode";
  return [
    "Objective",
    `Run Developer CAO oversight for ${label}.`,
    "",
    "Codex Responses goal",
    link.goal,
    "",
    "Workspace",
    link.repo || "(repo supplied by CAO-developer-mode)",
    "",
    "Plan file",
    link.plan || "(discover or create the active plan file)",
    "",
    "Cadence",
    "- Check Codex Responses hourly.",
    "- Verify planning, implementation, and testing evidence.",
    "- Surface a debrief when debugging completes or blocks.",
    "",
    "Guardrails",
    "- This is developer mode, not the global app-user support stream.",
    "- Do not file FS app-user support tickets unless TP explicitly approves.",
    "- Preserve unrelated local changes and keep validation evidence concrete.",
  ].join("\n");
}
